export default "__VITE_ASSET__a21697a3__"